import { create } from 'zustand';
import { ISearchResult } from '../models';

interface ISearchState {
  searchResult: ISearchResult[];
  setSearchResult: (results: ISearchResult[]) => void;
}

export const searchStore = create<ISearchState>((set) => ({
  searchResult: [],
  setSearchResult: (results: ISearchResult[]) => set({ searchResult: results }),
}));
